/* ============================================
   ET - Stock bar
   Runs the fill from 0 to its configured value once the block is on screen.
   The value itself is static — this is presentation only.
   ============================================ */
(function () {
  'use strict';

  var SEL = '[data-et-stock-bar]';

  function fill(el) {
    if (el.dataset.etStockBarFilled === 'true') return;
    el.dataset.etStockBarFilled = 'true';
    /* Next frame, so the 0-width starting state is painted before the change. */
    requestAnimationFrame(function () {
      el.classList.add('is-filled');
    });
  }

  function initSection(el) {
    if (!('IntersectionObserver' in window)) {
      fill(el);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, self) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          fill(entry.target);
          self.unobserve(entry.target);
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(el);
  }

  function init(scope) {
    (scope || document).querySelectorAll(SEL).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Re-run after a theme-editor edit or a variant-driven section re-render. */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) init(event.target);
  });
})();
